import { computed, ref } from '@vue/composition-api';

const price = ref(null);
const period = ref(null);
const plan = ref(null);
const paymentDialog = ref(false);
const driver = ref(null);
const needFirstPayment = ref(false);
const needNewCard = ref(false);
const method = ref(null);
const paymentAddress = ref({});

export default function usePayment() {
  function setPeriod(periodData) {
    period.value = periodData;
  }

  function setPlan(planData) {
    plan.value = planData;
  }

  function setDriver(driverCode) {
    driver.value = driverCode;
  }

  function setPaymentAddress(payload) {
    paymentAddress.value = payload;
  }

  const priceCalculated = computed(() => {
    if (!price.value || !period.value) {
      return {};
    }
    return {
      ...price,
      withDiscount: price.value.value * ((100 - period.value.discountPercent) / 100),
    };
  });

  return {
    price,
    plan,
    priceCalculated,
    period,
    paymentDialog,
    needFirstPayment,
    setPeriod,
    setDriver,
    setPlan,
    driver,
    method,
    needNewCard,
    paymentAddress,
    setPaymentAddress,
  };
}
